// services/dashboardService.js
import http from "./http";

export const getDashboardData = async () => {
  // Ensure your 'http' instance is configured to include the 
  // Bearer Token in the Authorization header.
  const res = await http.get("principal-dashbord");
  return res.data;
};

export const getTodayOverview = async () => {
  const res = await http.get("today_overviewapi");
  return res.data;
};